import { render, staticRenderFns } from "./RoleDia.vue?vue&type=template&id=60d9c67a&scoped=true"
import script from "./RoleDia.vue?vue&type=script&lang=js"
export * from "./RoleDia.vue?vue&type=script&lang=js"
import style0 from "./RoleDia.vue?vue&type=style&index=0&id=60d9c67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9c67a",
  null
  
)

export default component.exports